// extracted by mini-css-extract-plugin
export default {"mainWrapper":"CourseLevelInterestForm_mainWrapper__hmSTH","courseCategoriesHolder":"CourseLevelInterestForm_courseCategoriesHolder__fW+Q5"};